import { render, staticRenderFns } from "./relations-table.vue?vue&type=template&id=63563c3c&scoped=true&"
import script from "./relations-table.vue?vue&type=script&lang=js&"
export * from "./relations-table.vue?vue&type=script&lang=js&"
import style0 from "./relations-table.vue?vue&type=style&index=0&id=63563c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63563c3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDataTable,VRow,VSpacer})
